import AdminSideBar from "../components/adminSideBar";
import adminImg from "../media/adminImg.png"
import { db } from "../firebase/firebaseConfig";
import useGenStore from "../store/genstore";
import { doc,getDoc,updateDoc,orderBy,query } from "firebase/firestore";
import { BouncyArc } from "ldrs/react";
import "ldrs/react/BouncyArc.css";
import ClearedOrders from "../components/clearedOrders";
import axios from "axios";
import { useEffect, useState } from "react";
import "../css/admin.css"
import { Icon } from "@iconify/react";
import { collection,getDocs,onSnapshot } from "firebase/firestore";
import Emails from "../components/emails";
import Analytics from "../components/analytics";
import Loader from "./loader";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase/firebaseConfig";
import AdminDashboard from "../components/adminDashboard";
import useFirebaseStore from "../store/firebasestore";
import Swal from "sweetalert2";
function Admin(){

    const viewAdminDashboard = useGenStore((s)=>s.viewAdminDashboard)
    const viewAnalytics = useGenStore((s)=>s.viewAnalytics)
    const OrderStatusOnView = useGenStore((s)=>s.OrderStatusOnView)
    const setAdminName = useFirebaseStore((s)=>s.setAdminName)
    const setUserID = useFirebaseStore((s)=>s.setUserID)
    const setTotalUsers = useGenStore((s)=>s.setTotalUsers)
    const adminSideNav = useGenStore((s)=>s.adminSideNav)
    const setTotalEarnings = useGenStore((s)=>s.setTotalEarnings)
   const setAdminOrders = useFirebaseStore((s)=>s.setAdminOrders)
   const setClearedOrders = useFirebaseStore((s)=>s.setClearedOrders)
   const adminOrders = useFirebaseStore((s)=>s.adminOrders)
    const navigate= useNavigate()
            const pageInView = useGenStore((s)=>s.pageInView)
            const orderPop = useGenStore((s)=>s.orderPop)
            const setOrderPopUp = useGenStore((s)=>s.setOrderPopUp)
            const setMonthlySales = useGenStore((s)=>s.setMonthlySales)
            const orderOnView = useGenStore((s)=>s.orderOnView)
            const [screenLoader, setScreenLoader]= useState(true)
            const setIsAdmin = useFirebaseStore((s)=>s.setIsAdmin)
            const AdminName = useFirebaseStore((s)=>s.AdminName)
    const viewEmails = useGenStore((s)=>s.viewEmails)
    const viewClearedOrders = useGenStore((s)=>s.viewClearedOrders)
    const [Dest, setDest] = useState("")
    const [Fon, setFon] = useState("")
    const setAdminSideNav = useGenStore((s)=>s.setAdminSideNav)
    const clearedOrders = useFirebaseStore((s)=>s.clearedOrders)
    const [OrderId, setOrderId] = useState("")
    const [clearLoader, setClearLoader] = useState(false)
    const [cartItems, setCartItems] = useState([])
    const [FAdminName,setFAdminName]= useState("")
    const [orderName,setOrderName]= useState("")

  useEffect(() => {

  let unsubOrders = null;

  const unsubscribe = auth.onAuthStateChanged(async (user) => {
    if (!user) return;
    const token = await user.getIdTokenResult();
    setUserID(user.uid);

    if (token.claims.admin) {

      const userRef = doc(db, "Users", user.uid);
      const userSnap = await getDoc(userRef);
      if (userSnap.exists()) {
        const name = userSnap.data().name;
        setIsAdmin(true);
        setAdminName(name);
        setScreenLoader(false);
      } else {
        console.log("no such doc");
      }

  // 🔴 REALTIME ORDERS LISTENER
const ordersRef = collection(db, "Orders");

const q = query(ordersRef, orderBy("createdAt", "desc")); // newest first

unsubOrders = onSnapshot(q, (snapshot) => {
  const allOrders = snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }));

  const pendingOrders = allOrders.filter(order => order.status === "success");
  const clearedOrders = allOrders.filter(order => order.status === "cleared");

  setAdminOrders(pendingOrders);
  setClearedOrders(clearedOrders);
});
const usersRef = collection(db, "Users");

unsubOrders = onSnapshot(usersRef, (snapshot) => {
  const totalUsers = snapshot.docs.length; // ✅ number of users
  setTotalUsers(totalUsers);

  // Optional: map user data if you need it
  const allUsers = snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }));

});
const statsRef = collection(db, "Stats");

const unsubStats = onSnapshot(statsRef, (snapshot) => {
  // If you want total documents in Stats
  const totalStatsDocs = snapshot.docs.length;
  console.log("Total stats docs:", totalStatsDocs);

  // If you want to get the earnings doc specifically
  const earningsDoc = snapshot.docs.find(doc => doc.id === "earnings");
  if (earningsDoc) {
    const earnings = earningsDoc.data().totalRevenue;
    setTotalEarnings(earnings);

  }
});

const year = new Date().getFullYear().toString();

const salesRef = doc(db, "Stats", "Sales", "years", year);
const snap = await getDoc(salesRef);

if (snap.exists()) {
  const monthlyData = snap.data();
  setMonthlySales(monthlyData);
}

    } else {
      navigate("/");
    }

  });

  return () => {
    unsubscribe();
    if (unsubOrders) unsubOrders();
  };

}, []);
useEffect(()=>{
  const deOrder = adminOrders.find(order => order.id === orderOnView)
  if(orderOnView !== null && deOrder) {
    setDest(deOrder.destination);
    setFon(deOrder.phone);
    setOrderId(deOrder.id);
    setOrderName(deOrder.userName);
    setCartItems(deOrder.cartItems);
  }
}, [orderOnView, adminOrders]);
useEffect(()=>{
  const deOrder = clearedOrders.find(order => order.id === orderOnView)
  if(orderOnView !== null && deOrder) {
    setDest(deOrder.destination);
    setFon(deOrder.phone);
    setOrderId(deOrder.id);
    setOrderName(deOrder.userName);
    setCartItems(deOrder.cartItems);
  }
}, [orderOnView, clearedOrders]);
const formatDateTime = (date) => {
  const day = date.getDate();
  const daySuffix = day % 10 === 1 && day !== 11 ? "st" :
                    day % 10 === 2 && day !== 12 ? "nd" :
                    day % 10 === 3 && day !== 13 ? "rd" : "th";

  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = months[date.getMonth()];
  const year = date.getFullYear().toString().slice(-2);

  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "pm" : "am";

  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'

  return `${day}${daySuffix} ${month} '${year} ${hours}:${minutes}${ampm}`;
};
useEffect(()=>{
  
  setFAdminName((AdminName.split(" "))[0])
},[AdminName])

/**
 * Marks an order as cleared in Firestore
 * @param {string} orderId - The ID of the order to clear
 */
const clearOrder = async (orderId) => {
  if (!orderId) return;

  try {
    setClearLoader(true)
    const orderRef = doc(db, "Orders", orderId);
    const clearedAt = formatDateTime(new Date());

    await updateDoc(orderRef, {
      status: "cleared",
      clearedAt: clearedAt
    });

    Swal.fire("Cleared",`This order has been cleared successfuly`,"success");
        setClearLoader(false)
        setOrderPopUp(false)

  } catch (error) {
    
            setClearLoader(false)
            Swal.fire("Error","Failed to clear order","error")

    console.error("Failed to clear order:", error);
  }
};

 
    return (
        <>
        
        {screenLoader ? (<Loader/>):( 
          <div className="adminWrap">
            {orderPop && 
        
             <div className="orderPopUp">
            <div className="orderPopCard">
                <div className="orderPopUpCont">
                    <div className="orderPopUpTop">
                        <p>{Dest}</p>
                        <p>{Fon}</p>
                    </div>
                    <div className="orderPopUpMid">
                      {cartItems.map((item,index)=>(
   <div className="opmRow">
                            <div className="opmRowMini">
                                <p>{item.studentName}</p>
                                <span>Student</span>
                            </div>
                            <div className="opmRowMini">
                                <p>{item.sltSticker}</p>
                                <span>Sticker</span>
                            </div>
                            <div className="opmRowMini">
                                <p>{item.labelType}</p>
                                <span>Type</span>
                            </div>
               
                            <div className="opmRowMini">
                                <p>{item.count} pieces</p>
                                <span>Quantity</span>
                            </div>
              
                        </div>
                      ))}
                     
                    </div>
                    <div className="orderPopUpBtm">
                      {clearLoader ? (

                         <BouncyArc
                        size="60"
                        speed="1"
                        color="#25A9E1"
                      ></BouncyArc>
                      ): <> 
                      <button onClick={()=>setOrderPopUp(false)}>Back</button>
                  {OrderStatusOnView == "success" ? (  <button onClick={()=>clearOrder(OrderId,orderName)}>Clear</button>):("")}
                      </>
                      }
                      
                    </div>
                </div>
            </div>
             </div>
             }
      
            <div className={`adminLeft ${adminSideNav ? "adminLeftActive":""}`}>
                <AdminSideBar />
            </div>
            <div className="adminRight">
                <div className="adminMiniDash">
                      <div className="amdLeft">
                        <div className="amdLeftTop">
                            <span>Hello {FAdminName} 👋,</span>
                        </div>
                        <div className="amdLeftBtm">
                            <span>{pageInView}</span>
                        </div>
                      </div>
                      <div className="amdRight">
                        <div className="amdRightImgCover">
                            <img src={adminImg} alt="" />
                        </div>
                        <div className="amdRightIcon" onClick={()=>setAdminSideNav(true)}>
                          <Icon className="faIcon" icon="solar:alt-arrow-right-outline"/>
                        </div>
                      </div>
                </div>
                <div className="adminMainDashWraepper">
                    <div className={`dashBoardDrawer ${viewAdminDashboard ? "dashBoardDrawerActive" : ""}`} >
                         <AdminDashboard />
                    </div>
                    <div className={`dashBoardDrawer ${viewClearedOrders ? "dashBoardDrawerActive" : ""}`} >
                         <ClearedOrders />
 
                    </div>
                    <div className={`dashBoardDrawer ${viewAnalytics ? "dashBoardDrawerActive" : ""}`} >
                         <Analytics />
 
                    </div>
                    <div className={`dashBoardDrawer ${viewEmails ? "dashBoardDrawerActive" : ""}`} >
                         <Emails />
 
                    </div>

                </div>
            </div>
            

        </div>)}
        
        </>
       
    )
}
export default Admin;